/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".audit__title[_ngcontent-%COMP%]{margin-bottom:2rem}.audit__subtitle[_ngcontent-%COMP%]{margin-bottom:1rem}.audit__loading[_ngcontent-%COMP%]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}.audit__subsection[_ngcontent-%COMP%]{max-width:1280px;margin-top:2rem}.audit__subsection[_ngcontent-%COMP%]:last-of-type{min-height:calc(100vh - 2rem - 10px)}"];
export { styles as styles };
